import { useEffect, useState } from "react";
import styles from "../../../homepage/pages/Calculators.module.css";
import { analytics, logEvent } from "../../../../firebase.js";

import { BlockMath, InlineMath } from "react-katex";
import "katex/dist/katex.min.css";

import Select from "../components/Select.js";
import InputNumber from "../components/InputNumber.js";
import Output from "../components/Output.js";
import CrossBar from "../components/CrossBar.js";

import { concreteShearTorsion } from "../../utils/services/calculators.js";
import { Text, useToast } from "@chakra-ui/react";

function ConcreteShearTorsionTorsion({}) {
  const toast = useToast();
  // SHEAR
  const [shearTorsionInputs, setShearTorsionInputs] = useState({
    fck: 20,
    fyk: 500,
    b: "",
    h: "",
    dl: "",
    c1: "",
    vsd: "",
    tsd: "",
    model: "I",
    teta: 45,
    stress_type: "Flexão simples/Flexo-tração (LN corta a seção)",
    m0: "",
    msd_max: "",
  });
  const [shearTorsionOutputs, setShearTorsionOutputs] = useState({
    vrd2: "",
    asw: "",
    asw_min: "",
    trd2: "",
    a90: "",
    a90_min: "",
    asl: "",
    asl_min: "",
    memorial: {},
  });

  function updateShearTorsionInputs(name, value) {
    if (name === "stress_type" || name === "model") {
      setShearTorsionInputs((prevInputs) => ({
        ...prevInputs,
        [name]: value,
      }));
      if (name === "model" && value === "I") {
        setShearTorsionInputs((prevInputs) => ({
          ...prevInputs,
          teta: 45,
        }));
      }
      if (name === "model" && value === "II") {
        setShearTorsionInputs((prevInputs) => ({
          ...prevInputs,
          teta: "",
        }));
      }
    } else if (value === "") {
      setShearTorsionInputs((prevInputs) => ({
        ...prevInputs,
        [name]: value,
      }));
    } else {
      setShearTorsionInputs((prevInputs) => ({
        ...prevInputs,
        [name]: parseFloat(value),
      }));
    }
    setShearTorsionOutputs({
      vrd2: "",
      asw: "",
      asw_min: "",
      trd2: "",
      a90: "",
      a90_min: "",
      asl: "",
      asl_min: "",
      memorial: {},
    });
  }

  function onShearTorsionCalculate() {
    if (
      shearTorsionInputs["b"] === "" ||
      shearTorsionInputs["h"] === "" ||
      shearTorsionInputs["dl"] === "" ||
      shearTorsionInputs["c1"] === "" ||
      shearTorsionInputs["vsd"] === "" ||
      shearTorsionInputs["tsd"] === "" ||
      shearTorsionInputs["teta"] === "" ||
      (shearTorsionInputs["stress_type"] === "Flexo-compressão" &&
        (shearTorsionInputs["m0"] === "" ||
          shearTorsionInputs["msd_max"] === ""))
    ) {
      toast({
        title: "Preencha todos os campos",
        status: "warning",
        isClosable: true,
      });
    } else if (
      shearTorsionInputs["b"] === 0 ||
      shearTorsionInputs["h"] === 0 ||
      shearTorsionInputs["dl"] === 0 ||
      shearTorsionInputs["c1"] === 0 ||
      shearTorsionInputs["vsd"] === 0 ||
      shearTorsionInputs["tsd"] === 0 ||
      shearTorsionInputs["teta"] === 0 ||
      (shearTorsionInputs["stress_type"] === "Flexo-compressão" &&
        shearTorsionInputs["msd_max"] === 0)
    ) {
      toast({
        title: "Os valores devem ser diferentes de 0",
        status: "warning",
        isClosable: true,
      });
    } else if (
      shearTorsionInputs["model"] === "II" &&
      (shearTorsionInputs["teta"] < 30 || shearTorsionInputs["teta"] > 45)
    ) {
      toast({
        title: "O ângulo teta deve possui um valor entre 30º e 45º",
        status: "warning",
        isClosable: true,
      });
    } else if (shearTorsionInputs["c1"] <= shearTorsionInputs["dl"]) {
      toast({
        title:
          "O c1 (distância entre o eixo da barra longitudinal e a face lateral do elemento) deve ser maior que o dl (distância entre o eixo da barra transversal e a face lateral do elemento)",
        status: "warning",
        isClosable: true,
      });
    } else {
      concreteShearTorsion(shearTorsionInputs).then((response) => {
        setShearTorsionOutputs(response["data"]);
        logEvent(analytics, "button_click", {
          button_name: "concrete-shearTorsion-calculator-button",
        });
      });
    }
  }

  useEffect(() => {
    logEvent(analytics, "page_view", {
      page: "concrete-shearTorsion-calculator",
    });
  }, []);

  return (
    <div className={styles.section} key={"header"}>
      <h1 className={styles.calculatorName}>Cisalhamento + Torção:</h1>
      <div className={styles.calculator}>
        <div className={styles.inputs}>
          <div className={styles.inputRow}>
            <h3 className={styles.rowTitle}>Dados de entrada:</h3>
          </div>
          <div className={styles.inputRow}>
            <Select
              text="Seção"
              elements={["Retangular"]}
              unit=""
              // onChange={(e) => updateBendingInputs("fck", e.target.value)}
            />
          </div>
          <div className={styles.inputRow}>
            <Select
              text="fck"
              elements={[
                20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90,
              ]}
              unit="MPa"
              onChange={(e) => updateShearTorsionInputs("fck", e.target.value)}
            />
            <Select
              text="fyk"
              elements={[500, 600]}
              unit="MPa"
              onChange={(e) => updateShearTorsionInputs("fyk", e.target.value)}
            />
          </div>
          <div className={styles.inputRow}>
            <InputNumber
              text="b"
              unit="cm"
              onChange={(e) => updateShearTorsionInputs("b", e.target.value)}
            />
            <InputNumber
              text="h"
              unit="cm"
              onChange={(e) => updateShearTorsionInputs("h", e.target.value)}
            />
          </div>
          <div className={styles.inputRow}>
            <InputNumber
              text="dl"
              unit="cm"
              onChange={(e) => updateShearTorsionInputs("dl", e.target.value)}
            />
            <InputNumber
              text="c1"
              unit="cm"
              onChange={(e) => updateShearTorsionInputs("c1", e.target.value)}
            />
          </div>
          <div className={styles.inputRow}>
            <InputNumber
              text="Vsd"
              unit="tf"
              onChange={(e) => updateShearTorsionInputs("vsd", e.target.value)}
            />
            <InputNumber
              text="Tsd"
              unit="tf.m"
              onChange={(e) => updateShearTorsionInputs("tsd", e.target.value)}
            />
          </div>
          <div className={styles.inputRow}>
            <Select
              text="Modelo"
              elements={["I", "II"]}
              unit=""
              onChange={(e) =>
                updateShearTorsionInputs("model", e.target.value)
              }
            />
            {shearTorsionInputs["model"] === "I" ? (
              <h4 className={styles.rowDescription}>θ=45º</h4>
            ) : (
              <InputNumber
                text="θ"
                unit="º"
                onChange={(e) =>
                  updateShearTorsionInputs("teta", e.target.value)
                }
              />
            )}
          </div>
          <div className={styles.inputElement}>
            <Select
              text="Caso"
              elements={[
                "Flexão simples/Flexo-tração (LN corta a seção)",
                "Elementos tracionados (LN fora da seção)",
                "Flexo-compressão",
              ]}
              unit=""
              onChange={(e) =>
                updateShearTorsionInputs("stress_type", e.target.value)
              }
            />
          </div>
          {shearTorsionInputs["stress_type"] === "Flexo-compressão" && (
            <div className={styles.inputRow}>
              <InputNumber
                text="M0"
                unit=""
                onChange={(e) => updateShearTorsionInputs("m0", e.target.value)}
              />
              <InputNumber
                text="Msd,máx"
                unit=""
                onChange={(e) =>
                  updateShearTorsionInputs("msd_max", e.target.value)
                }
              />
            </div>
          )}
        </div>
        <div className={styles.buttons}>
          <button
            className={styles.calculateButton}
            onClick={onShearTorsionCalculate}
          >
            CALCULAR
          </button>
        </div>
        <div className={styles.outputs}>
          <div className={styles.outputRow}>
            <h3 className={styles.rowTitle}>Resumo de resultados:</h3>
          </div>
          <h4 className={styles.rowDescription}>Cisalhamento</h4>
          <Output text="Vrd2" value={shearTorsionOutputs["vrd2"]} unit="kN" />
          <Output
            text="Asw"
            value={shearTorsionOutputs["asw"]}
            unit="cm²/m - 2R"
          />
          <Output
            text="Asw,mín"
            value={shearTorsionOutputs["asw_min"]}
            unit="cm²/m - 2R"
          />
          <h4 className={styles.rowDescription}>Torção</h4>
          <Output
            text="Trd2"
            value={shearTorsionOutputs["trd2"]}
            unit="kN.cm"
          />
          <Output
            text="A90"
            value={shearTorsionOutputs["a90"]}
            unit="cm²/m - 1R"
          />
          <Output
            text="A90,mín"
            value={shearTorsionOutputs["a90_min"]}
            unit="cm²/m - 2R"
          />
          <Output text="Asl" value={shearTorsionOutputs["asl"]} unit="cm²" />
          <Output
            text="Asl,mín"
            value={shearTorsionOutputs["asl_min"]}
            unit="cm²"
          />
          <h4 className={styles.rowDescription}>Torção + Cisalhamento</h4>
          {shearTorsionOutputs["asw"] !== "" && (
            <h4 className={styles.rowDescription}>
              {(
                (shearTorsionInputs["vsd"] * 10) /
                shearTorsionOutputs["vrd2"]
              ).toFixed(2) +
                " + " +
                (
                  (shearTorsionInputs["tsd"] * 1000) /
                  shearTorsionOutputs["trd2"]
                ).toFixed(2) +
                " ≤ 1  → "}
              {(shearTorsionInputs["vsd"] * 10) / shearTorsionOutputs["vrd2"] +
                (shearTorsionInputs["tsd"] * 1000) /
                  shearTorsionOutputs["trd2"] <=
              1
                ? "OK!"
                : "NÃO OK!"}
            </h4>
          )}
          <Output
            text="Asw+A90"
            value={shearTorsionOutputs["asw"] + 2 * shearTorsionOutputs["a90"]}
            unit="cm²/m - 2R"
          />
          <CrossBar fyk={shearTorsionInputs["fyk"]} />
        </div>
      </div>
      <div className={styles.memorial} key={"memorial"}>
        <h1>Memorial de Cálculo:</h1>
        {shearTorsionOutputs["memorial"] &&
          Object.entries(shearTorsionOutputs["memorial"]).map(
            ([className, subclasses]) => (
              <>
                <h2>{className}</h2>
                {Object.entries(subclasses).map(([subclassName, steps]) => (
                  <>
                    <h3>{subclassName}</h3>
                    {steps.map((step) => (
                      <>
                        <h4>{step["description"]}</h4>
                        <div className={styles.mathContainer}>
                          <BlockMath
                            math={step["formula"] + step["calculation"]}
                          />
                        </div>
                      </>
                    ))}
                  </>
                ))}
              </>
            )
          )}
      </div>
    </div>
  );
}

export default ConcreteShearTorsionTorsion;
